// React
import React from 'react'
import { compose } from 'redux'

// Components
import { CartPickerButton } from 'store/modules/cart/CartPicker/Button'

// Shared
import withStore from 'shop-components/utils/withStore'
import withTheme from 'shop-components/utils/withTheme'

const Button = () => <CartPickerButton />

const decoratedComponent = compose(
  withStore,
  withTheme
)(Button)

export default decoratedComponent
